import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import VentaEspecialAdmin from './VentaEspecial/VentaEspecialAdmin';
import VentaEspecialTienda from './VentaEspecial/VentaEspecialTienda';
import { Settings, ShoppingBag } from 'lucide-react';

const VentaEspecialView = () => {
    const { user } = useAuth();
    const isAdmin = user?.role === 'costos';
    const [viewMode, setViewMode] = useState('admin'); // 'admin' o 'tienda'

    return (
        <div className="animate-fadeIn pb-12 pt-4">
            <div className="flex justify-between items-center mb-4 flex-wrap gap-4 max-w-7xl mx-auto px-4">
                <h2 className="page-title">Productos SURA</h2>
            </div>
            {isAdmin && (
                <div className="max-w-7xl mx-auto px-4 mb-6">
                    <div className="inline-flex bg-gray-100 rounded-lg p-1">
                        <button
                            onClick={() => setViewMode('admin')}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${viewMode === 'admin'
                                    ? 'bg-white text-gray-900 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'
                                }`}
                        >
                            <Settings size={16} /> Administrar
                        </button>
                        <button
                            onClick={() => setViewMode('tienda')}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${viewMode === 'tienda'
                                    ? 'bg-white text-gray-900 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'
                                }`}
                        >
                            <ShoppingBag size={16} /> Comprar
                        </button>
                    </div>
                </div>
            )}

            {isAdmin && viewMode === 'admin' ? (
                <VentaEspecialAdmin />
            ) : (
                <VentaEspecialTienda />
            )}
        </div>
    );
};

export default VentaEspecialView;
